module.exports = __webpack_public_path__ + "static/media/sunarch_7.becb43fb.gif";